<div class="full_dialog">
    <div class="head_content"><img src="assets/icones/Logo-Volta.svg"
            class="logo">
        <div class="head_right_container">
            <div class="left_haed">
                <h4 class="black font1">{{"quotations_and_orders.rfq_detail"|translate}}</h4>
                <div class="head_of_listing">
                    <h5 class="title_catalog">{{"quotations_and_orders.quotations"|translate}}</h5><img
                        src="assets/icones/arrow_to_right.svg" alt="" class="arrow">
                    <h5>{{"quotations_and_orders.rfq_detail"|translate}} (ID : {{data.pricelist_id}})</h5>
                    <div class="back_block" (click)="close()">
                        <span class="back_span">{{"common.back"|translate | uppercase}}</span>
                        <img src="../../../assets/icones/arrow_back_small.svg" alt="">
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="head">
        <h2>({{productsSelected()}}) {{"quotations_and_orders.selected_and_product"|translate}}</h2>
        <div class="quantity border_lr">
            <h4>  {{"quotations_and_orders.quantity"|translate}}: </h4>
            <h2>{{totalQuantity()}}</h2>
        </div>
        <div class="quantity">
            <h4> {{"quotations_and_orders.subtotal"|translate}} :</h4>
            <h2>{{totalPrice() | number:'1.2-2'}} {{data.currency?.symbol}}</h2>
        </div>
        <div class="df gap-10 mla">
            <mat-slide-toggle class="toggle_final" [(ngModel)]="isFinalQuote"></mat-slide-toggle>
            <div class="df gap-10 block_lf">
                <img src="assets/icones/final-quote.svg" alt=""
                    class="icon1">
                <span class="fn_quote">{{"quotations_and_orders.final_quote"|translate}}</span>
            </div>
            <div class="hint-container">
                <img class="hint_icon" src="assets/icones/hint.svg" alt="">
                <span class="hint_descr">{{"quotations_and_orders.when_select"|translate}}</span>
            </div>
        </div>
    </div>
    <div class="filter_with_table">
        <form class="left_container" [formGroup]="form">
            <div class="field field_search">
                <input type="text" [placeholder]="'inventory.search_product' | translate"  [formControl]="nameControleProduct" class="input_search">
                <img src="assets/icones/search.svg" alt="" class="search_icon">
            </div>
            <div class="filters">
                <div class="head_filter">
                    <img src="assets/icones/filter.svg" alt="" class="filter_icon">
                    <h4 class="size_weight_color1 fs-medium m-0">{{"common.filters"|translate}}</h4>
                </div>
                <div class="fields">
                    <div class="field">
                        <label for="price-Min">{{"quotations_and_orders.min_stock"|translate}}</label>
                        <input type="text" formControlName="minStock">
                    </div>
                    <div class="field">
                        <label for="price-Max">{{"quotations_and_orders.max_stock"|translate}}</label>
                        <input type="text" formControlName="maxStock">
                    </div>
                </div>
                <div class="fields">
                    <div class="field">
                        <label for="price-Min">{{"quotations_and_orders.min_price"|translate }}</label>
                        <input type="text" formControlName="minPrice">
                    </div>
                    <div class="field">
                        <label for="price-Max">{{"quotations_and_orders.max_price"|translate}}</label>
                        <input type="text" formControlName="maxPrice">
                    </div>
                </div>
                <div class="field">
                    <label for="brands">{{ "brands.brands" | translate }}</label>
                    <select id="brands" formControlName="brands">
                      <option disabled selected value>
                        {{ "brands.all_brands" | translate }} ({{ brands?.length ?? 0 }})
                      </option>
                      <option *ngFor="let brand of brands" [value]="brand.id">
                        {{ brand.name }}
                      </option>
                    </select>
                  </div>

                  <div class="field">
                    <label for="categories">{{ "Categories.categories" | translate }}</label>
                    <select id="categories" formControlName="categories">
                      <option disabled selected value>
                        {{ "Categories.all_categories" | translate }} ({{ categories?.length ?? 0 }})
                      </option>
                      <option *ngFor="let category of categories" [value]="category.id">
                        {{ category.name }}
                      </option>
                    </select>
                  </div>
                <div class="fields">
                    <div class="field" (click)="clearFilters()"><a class="clear">{{"quotations_and_orders.clear_filter"|translate}}</a></div>
                    <div class="field"><button (click)="applyFilter()" class="cancel_btn_pop_up filter_btn">{{"common.apply"|translate}}</button></div>
                </div>
            </div>
        </form>
        <div class="list">
            <table [formGroup]="productsForm">
                <tr class="head_title tr3 header_stiky">
                    <th>
                        <mat-checkbox (change)="checkAllProducts($event)" [disabled]="allProductsDisable()" [checked]="isAllChecked()"></mat-checkbox>
                        <span class="ml-10">{{"common.image"|translate}}</span>
                    </th>
                    <th style="line-height: 13px !important;">
                        <div>{{"common.name"|translate}}<br>
                            <span class="gray">{{ productCode.primaryLabelKey | translate }}</span>
                        </div>
                    </th>
                    <th class="number_clmn">{{"inventory.stock"|translate}}</th>
                    <th class="number_clmn">{{"quotations_and_orders.quantity"|translate}}</th>
                    <th class="number_clmn">{{"Catalogs.retail_price"|translate}}</th>
                    <th class="number_clmn">{{"Catalogs.mark_up"|translate}}</th>
                    <th class="number_clmn">{{"Catalogs.discount"|translate}}</th>
                    <th class="number_clmn">{{"Catalogs.final_price"|translate}}</th>
                </tr>
                <ng-container *ngFor="let product of currentFilter">
                    <tr class="tr3 ng-star-inserted" [ngClass]="{ 'disabled_tr': product.status === 'Draft' ||  ((!product.stock || product.stock && product.stock.quantity < product.min_qte!) && product.is_owned ) ? true : false }" [class.is_killing_stock]="isKillingStock(product) && product.is_owned">
                        <td>
                            <mat-checkbox class="example-margin" [disabled]="product.status == 'Draft' || ((!product.stock || product.stock && product.stock.quantity < product.min_qte!) && product.is_owned ) ? true : false" [(ngModel)]="product.checked" [ngModelOptions]="{standalone: true}" (change)="checkProduct(product, $event)"></mat-checkbox>
                            <div class="img_product ml-10">
                                <img [src]="product.image ? baseUrl + product.image + '?thumbnail=1' : placeholder" alt="">
                            </div>
                        </td>
                        <td [class.td_killing_stock]="isKillingStock(product) && product.is_owned">
                            <div>
                                {{product.name}}
                                <br>
                                <span class="gray">{{product | productCode}}</span>
                            </div>
                            <span class="killing_stock_msg" *ngIf="isKillingStock(product) && product.is_owned">{{"quotations_and_orders.killing_stock_product"| translate}}</span>
                        </td>
                        <td class="number_clmn">
                            <ng-container *ngIf="product?.is_owned === false; else owned">
                                <span class="tag">
                                    {{'inventory.notOwned' | translate}}
                                </span>
                                </ng-container>
                                <ng-template #owned>
                                    <div>
                                    {{product.stock?.quantity}}
                                    </div>
                                </ng-template>
                        </td>
                        <td class="number_clmn">
                            <div>
                                <input type="number" class="input" [formControlName]="'quantity_' + product.product_id" [class]="productsForm.get('quantity_' + product.product_id)?.errors ? 'invalid' : ''" (input)="updateQuantity($event, product)">
                                <div class="exceeded_stock_msg" *ngIf="isKillingStock(product) && product.is_owned">{{"quotations_and_orders.stock_exceeded" | translate: {exceeded_stock: exceededStock(product)} }}</div>
                                <div *ngIf="productsForm.get('quantity_' + product.product_id)?.errors">
                                    <span class="error-message">
                                        {{ productsForm.get('quantity_' + product.product_id)?.errors?.['quantityInvalid'] }}
                                        {{ productsForm.get('quantity_' + product.product_id)?.errors?.['quantityMin'] }}
                                        {{ productsForm.get('quantity_' + product.product_id)?.errors?.['quantityMax'] }}
                                        {{ productsForm.get('quantity_' + product.product_id)?.errors?.['quantityIncrement'] }}
                                    </span>
                                </div>
                                <div class="item last_td hint">
                                    <span>{{"quotations_and_orders.quantity_rule"|translate}}</span>
                                    <button mat-button [matMenuTriggerFor]="menu">
                                        <img src="assets/icones/rule.svg" alt="" class="info_hint">
                                    </button>
                                    <mat-menu xposition="after" #menu="matMenu">
                                        <div class="cover_div">
                                            <div class="info_hint">
                                                <span>{{"quotations_and_orders.quantity_rule"|translate}}</span>
                                            </div>
                                            <div class="spans">
                                                <span>{{"Catalogs.min"|translate}}: {{product.min_qte}}</span>
                                                <span>{{"Catalogs.max"|translate}}: {{product.max_qte}}</span>
                                                <span>{{"Catalogs.increment"|translate}}: {{product.increment}}</span>
                                            </div>
                                        </div>
                                    </mat-menu>
                                </div>
                            </div>
                        </td>
                        <td class="number_clmn">
                            {{product.price_unit ? product.price_unit + ' ' + data.currency?.symbol : '--'}}
                        </td>
                        <td class="number_clmn">
                            {{product.price_unit ? (product.price_unit - product.cost) + ' ' + data.currency?.symbol : '--' }}
                        </td>
                        <td class="number_clmn">
                            <div class="last_td" *ngIf="product.price_unit">
                                <input [(ngModel)]="product.discount" type="number" class="input" [ngModelOptions]="{standalone: true}" [disabled]="!product.checked" (input)="updateDiscount($event, product)" title="">
                                <span class="indicate_input">%</span>
                            </div>
                        </td>
                        <td class="number_clmn">
                            <div  [style]="{
                              display: 'flex',
                              flexDirection: 'column',
                              alignItems: 'end'
                            }"  >
                              <div class="last_td" [style]="{
                                width: '72px'
                              }">
                                <input [formControlName]="'final_price_' + product.product_id" type="number" [value]="product.final_price" class="input" [style]="{
                                  width: '100%',
                                  boxSizing: 'border-box'
                                }" [disabled]="!product.checked" (input)="updateFinalPrice($event, product)">
                                    <span class="indicate_input">{{data.currency?.symbol}}</span>
                              </div>
                              <span class="error_ms" *ngIf="productsForm.get('final_price_' + product.product_id )?.touched  && productsForm.get('final_price_' + product.product_id )?.errors">
                                  {{"common.required_field" | translate}}
                                </span>
                            </div>
                        </td>
                    </tr>
                </ng-container>
            </table>
        </div>
    </div>
    <div class="actions">
        <button class="save_btn_pop_up cancel_btn_pop_up" (click)="close()">
            <span>{{"common.back"|translate | uppercase}}</span>
            <img src="../../../../../assets/icones/arrow_back.svg" alt="">
        </button>
        <button class="action_btn btn_edit mta"
            style="opacity: 0.5; cursor: not-allowed;">
            <mat-icon style="color: #6449DB;">save</mat-icon>
            <span>{{"common.save"|translate | uppercase}} {{"common.as"|translate}} {{"common.draft"|translate}}</span>
        </button>
        <button class="save_btn_pop_up green_btn" (click)="SendQuotation()">
            <span>{{"quotations_and_orders.send_quote"|translate}}</span>
            <img alt="" src="../../../../../assets/icones/arrow_circle_right.svg">
        </button>
    </div>
</div>
